<div class="mt-3">
    <span class="font-bold">{{unitLabel}}</span>  
    &nbsp;
    <p-dropdown [options]="warehouseList" appendTo="body" [(ngModel)]="selectedWarehouse" optionLabel="warehouseName"
        placeholder="Select a {{unitLabel}}" styleClass="w-3">
        <ng-template let-item pTemplate="item">
            <span>{{item.warehouseCode}} - {{item.warehouseName}}</span>
        </ng-template>
    </p-dropdown>
    &nbsp;
    <p-button label="Go" (onClick)="searchByWarehouse()" [raised]="true" severity="info" />
</div>


<p-table #dt1 [value]="ledger" responsiveLayout="scroll" class="w-full m-5" styleClass="p-datatable-sm "
    selectionMode="single" [paginator]="true" [rows]="6" (onPage)="loadLedgerTransaction($event)">
    <ng-template pTemplate="header">
        <tr>
            <!-- <th><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th> -->
            <th>Transaction No </th>
            <th>Transaction Type</th>
            <th>Date / Time</th>
            <th>Qty</th>
            <th>UOM</th>
            <th>Beginning Balance</th>
            <th>Debit</th>
            <th>Credit</th>
            <th>Ending Balance</th>
            <th>FIFO Unit Cost</th>
            <th>FIFO Total Cost</th>
            <th>Running Stock Value</th>
            <!-- <th>Beginning Weight</th> -->
            <!-- <th>Actual Weight</th> -->
            <!-- <th>Ending Weight</th> -->
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-data>
        <tr>
            <td>{{data.transactionNo}}</td>
            <td>{{data.transactionType}}</td>
            <td>{{data.transactionDate | date: 'dd/MM/yyyy hh:mm:ss a'}}</td>
            <td>{{data.quantity}}</td>
            <td>{{data.uom}}</td>
            <td>{{data.beginingQuantity}}</td>
            <td>{{data.debitQuantity}}</td>
            <td>{{data.creditQuantity}}</td>
            <td>{{data.endingQuantity}}</td>
            <td>
                {{ (data.fifoUnitCost ?? 0).toLocaleString('en-IN',{
                minimumFractionDigits: 4, maximumFractionDigits: 4 }) }}
            </td>
            <td>
                {{ (data.fifoTotalCost ?? 0).toLocaleString('en-IN',{
                minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
            </td>
            <td>
                {{ (data.runningStockValue ?? 0).toLocaleString('en-IN',{
                minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
            </td>
            <!-- <td>{{data.beginingWeight}}</td> -->
            <!-- <td>{{data.actualWeight}}</td> -->
            <!-- <td>{{data.endingWeight}}</td> -->

        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="5">No data found.</td>
        </tr>
    </ng-template>
</p-table>
